import { commonMistakeCodes, passCodes } from '../passCodes';
import track10 from '../../../../assets/audio/tracks/track10.mp3';

const hints = [
    {
        text: 'Pořádně si sochu prohlédněte, není to jen tak, je potřeba se podívat ze všech stran.',
    },
    {
        text: 'Nejedná se o vyobrazení na soše ale o podpis autora, mimo to je to i poměrně exotický pták s velkým zobákem.',
    },
    {
        text: 'Kódem je: pelikán',
        solution: true,
    },
];
export const step10statue = {
    id: 10,
    title: '4. stanoviště',
    taskText: `
        <p>
            Máš? Tak super, já už mám zase nápad kam teď. Co takhle dolů a doprava? Kousek odtud je super park a tam určitě taky nějací ptáci budou. Tady žádní nebyli. 
        </p>
        <p>    
            Jo a po cestě je tam taková zajímavá socha s pánem a věncem, u toho se zastavíme. Často mi dává dobré informace, a navíc u něj je hned několik dalších ptáků. 
        </p>
        <p>    
            Jednoho z nich jsem dokonce ani nikdy neviděl, a to bych řekl, že jich znám hodně.
        </p>
    `,
    cipher: {
        text: 'Víte o jakého se jedná? Napište jeho jméno.',
        label: 'Úkol',
    },
    catImage: 7,
    audio: track10,
    snowAudio: track10,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[6],
    codeInputPassCodeCommonMistakeRegexp: [commonMistakeCodes[2]],
    codeInputPassCodeCommonMistakeMessage: ['Nečetli jste pořádně zadání, podívejte se na něj znovu'],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
